import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import locales from '../../constants/locales';

let resources = {};
const generateLangResource = () => {
  for (const code of locales) {
    resources = {
      ...resources,
      [Object.keys(code)[0]]: {
        translation: Object.values(code)[0]
      }
    };
  }
  return resources;
};

i18n.use(initReactI18next).init({
  debug: true,
  fallbackLng: localStorage.getItem('lang_code') || 'en',
  interpolation: {
    escapeValue: false
  },
  // language resources
  resources: generateLangResource()
});

export default i18n;
